/**
 * Bundle Pack Builder — colour-first
 *
 * Every colour on this store is its own product, and the colour swatches are
 * rendered by the Easify Product Options app as <a href="/products/...">.
 *
 * Old behaviour: pick a quantity first, then you were allowed to pick exactly
 * that many colours; extra clicks were silently ignored and a click could send
 * you off to another product page (or a 404 if the linked product was gone).
 *
 * New behaviour: the colour swatches ARE the quantity control.
 *   - Click a colour  -> one of that colour is added to the pack
 *   - Click it again  -> two of that colour, and so on (no cap)
 *   - Quantity + discount tier follow the pack total automatically
 *   - Nothing ever navigates: no page load, no refresh
 *   - Colours whose product no longer exists are detected up front and
 *     disabled, instead of dumping the customer on a 404
 *
 * The quantity tiers are a GOAL, never a command. Tapping "3 Pack" says "I'm
 * aiming for three" — it previews that price and counts you down, but it never
 * chooses a colour for you and never removes a colour you already chose. The
 * pack you built is always what goes in the cart.
 */
(function () {
  'use strict';

  var tiersWrap = document.getElementById('BundleTiers');
  if (!tiersWrap) return;

  var hiddenInput = document.getElementById('BundleQtyInput');
  if (!hiddenInput) return;

  var colorSection = document.getElementById('BundleColors');
  var countEl = colorSection ? colorSection.querySelector('[data-bundle-color-count]') : null;
  var picksEl = colorSection ? colorSection.querySelector('[data-bundle-picks]') : null;
  var noticeEl = colorSection ? colorSection.querySelector('[data-bundle-notice]') : null;

  var productSection = document.querySelector('[data-section-type="product"]');
  var form = tiersWrap.closest('form[action*="/cart/add"]');

  var basePrice = parseInt(tiersWrap.getAttribute('data-product-price'), 10) || 0;
  var moneyFormat = tiersWrap.getAttribute('data-money-format') || '${{amount}}';

  var addToCartBtn = document.querySelector('.ProductForm__AddToCart');
  var addToCartPriceSpan = addToCartBtn ? addToCartBtn.querySelectorAll('span') : [];

  // The colour this page itself is. It never needs a lookup — Liquid gave us
  // the variant id directly.
  var current = {
    handle: colorSection ? (colorSection.getAttribute('data-current-handle') || '') : '',
    variantId: colorSection ? (colorSection.getAttribute('data-current-variant-id') || '') : '',
    label: colorSection ? (colorSection.getAttribute('data-current-color') || '') : '',
    image: colorSection ? (colorSection.getAttribute('data-current-image') || '') : ''
  };

  // picks: [{ handle, label, variantId, image, style, qty }] in click order
  var picks = [];
  // The tier the customer is aiming for. Purely a target: it drives the
  // "2 more to go" copy and the price preview, and it is what gets added if
  // they never touch a swatch. It is cleared the moment the pack reaches it.
  var targetQty = 0;
  var lastTouched = current.handle;
  var productCache = {};   // handle -> product data | null (null = gone)
  var productPromises = {};

  window.__bundleMode = { active: true };

  // ── tier data ───────────────────────────────────────────────────────────────
  var tiers = tiersWrap.querySelectorAll('.BundleTier');
  var tierData = [];
  tiers.forEach(function (t) {
    tierData.push({
      qty: parseInt(t.getAttribute('data-tier-qty'), 10),
      discount: parseInt(t.getAttribute('data-tier-discount'), 10) || 0,
      el: t
    });
  });

  function total() {
    var n = 0;
    picks.forEach(function (p) { n += p.qty; });
    return n;
  }

  // ── product lookup ──────────────────────────────────────────────────────────
  // Resolves a product handle to { variantId, title, colour, image } or null if
  // the product no longer exists (deleted, renamed, unpublished).
  function resolveProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (handle === current.handle && current.variantId) {
      return Promise.resolve({
        variantId: current.variantId,
        colour: current.label,
        image: current.image,
        available: true
      });
    }
    if (Object.prototype.hasOwnProperty.call(productCache, handle)) {
      return Promise.resolve(productCache[handle]);
    }
    if (productPromises[handle]) return productPromises[handle];

    productPromises[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (!data || !data.variants || !data.variants.length) {
          productCache[handle] = null;
          return null;
        }
        var variant = data.variants.filter(function (v) { return v.available; })[0] || data.variants[0];
        var image = (data.images && data.images[0]) || data.featured_image || '';
        if (image) image += (image.indexOf('?') > -1 ? '&' : '?') + 'width=80';
        productCache[handle] = {
          variantId: String(variant.id),
          // Product titles are "Aura Sarong - Strawberry", so the colour is the
          // last segment. This is more trustworthy than the handle, which on
          // this store is often a leftover from duplicating another product.
          colour: (data.title || '').split(' - ').pop().trim() || data.title,
          image: image,
          available: !!variant.available
        };
        return productCache[handle];
      })
      .catch(function () { productCache[handle] = null; return null; });

    return productPromises[handle];
  }

  // ── swatch helpers ──────────────────────────────────────────────────────────
  // The app writes swatch links as absolute URLs on the shop's public domain.
  // The host is deliberately not checked: a theme preview runs on
  // *.myshopify.com while those links still say snakesandshanti.com, and an
  // origin test there would quietly stop recognising every swatch. What makes
  // this safe is isSwatch() — we only ever read links inside the app's own
  // option block.
  function handleFromUrl(href) {
    if (!href || href.indexOf('/products/') === -1) return '';
    var url;
    try { url = new URL(href, window.location.origin); } catch (e) { return ''; }
    var handle = url.pathname.split('/products/')[1] || '';
    return handle.split('/')[0].split('?')[0].split('#')[0];
  }

  function handleFromSwatch(el) {
    var a = el.tagName === 'A' ? el : el.closest('a[href]');
    if (!a) return '';
    return handleFromUrl(a.getAttribute('href') || '');
  }

  function labelFromSwatch(el) {
    var node = el.querySelector('.tpo_color-swatches-tooltip, .tpo_image-swatches-tooltip, .tpo_option_type_label, [class*="tooltip"]');
    var text = node ? node.textContent.trim() : '';
    if (!text) {
      var input = el.querySelector('input[type="radio"], input[type="checkbox"]');
      if (input && input.value) text = input.value;
    }
    if (!text) {
      text = el.getAttribute('data-tooltip') || el.getAttribute('title') || el.getAttribute('data-value') || '';
    }
    return text.split('[')[0].replace(/\s*[-–]\s*sold out\s*$/i, '').trim();
  }

  // The colour itself, lifted off the swatch the customer tapped. Read from the
  // computed style rather than the style attribute, because the app puts the
  // colour on a stylesheet rule as often as it puts it inline.
  function styleFromSwatch(el) {
    var candidates = [];
    var inner = el.querySelector('[style*="background"], [class*="swatch"], [class*="Swatch"]');
    if (inner) candidates.push(inner);
    candidates.push(el);

    for (var i = 0; i < candidates.length; i++) {
      var node = candidates[i];
      var css = '';
      try {
        var computed = getComputedStyle(node);
        var img = computed.backgroundImage;
        var col = computed.backgroundColor;
        // A pattern swatch's own artwork beats its flat colour; both beat the
        // product photo.
        if (img && img !== 'none') {
          css = 'background-image:' + img + ';background-size:cover;background-position:center;';
        } else if (col && col !== 'transparent' && col !== 'rgba(0, 0, 0, 0)') {
          css = 'background-color:' + col + ';';
        }
      } catch (e) {}
      if (!css) {
        var attr = node.getAttribute('style') || '';
        if (attr.indexOf('background') > -1) css = attr;
      }
      if (css) return css;
    }
    return '';
  }

  // Easify ships its whole option catalogue on every product page — every
  // colour, its hex code and the product it links to. That is the authoritative
  // answer for "what colour is this handle", better than scraping whatever got
  // rendered, and it covers colours whose swatch isn't on this page at all
  // (a pack built on the Om Sarong and carried over to the Aura Sarong).
  var colourMap = null;
  function colourCatalog() {
    if (colourMap) return colourMap;
    colourMap = {};
    var sets = window.TPOConfigs && window.TPOConfigs.product_options_easify;
    if (!sets || !sets.length) return colourMap;

    sets.forEach(function (entry) {
      var options = (entry && entry.option_set && entry.option_set.options) || [];
      options.forEach(function (opt) {
        (opt.option_types || []).forEach(function (t) {
          var url = '';
          try { url = (JSON.parse(t.metadata || '{}') || {}).url || ''; } catch (e) {}
          var handle = handleFromUrl(url);
          if (!handle || colourMap[handle]) return;

          // Stored as "#624021ff," — 8-digit hex with a stray trailing comma.
          var code = String(t.color_code || '').split(',')[0].trim();
          var css = '';
          if (/^#[0-9a-f]{3,8}$/i.test(code)) {
            css = 'background-color:' + code + ';';
          } else if (t.image_url) {
            css = "background-image:url('" + t.image_url + "');background-size:cover;background-position:center;";
          }
          if (!css) return;
          colourMap[handle] = { label: String(t.label || '').trim(), css: css };
        });
      });
    });
    return colourMap;
  }

  // For picks that arrived without a swatch to read — restored from a previous
  // page, or topped up by the +/- buttons.
  function styleForHandle(handle) {
    var known = colourCatalog()[handle];
    if (known && known.css) return known.css;

    var found = '';
    allSwatches().some(function (a) {
      if (handleFromSwatch(a) !== handle) return false;
      found = styleFromSwatch(a);
      return !!found;
    });
    return found;
  }

  // A colour swatch is a short link to another product sitting inside the
  // option UI — not a prose link in the description, not a gallery thumbnail.
  function isSwatch(el) {
    if (!el) return false;
    // App-rendered swatches identify themselves by class, so we accept them
    // wherever the app decided to inject them. Falling back to "must be inside
    // the product section" would mean a single layout change silently returns
    // the swatches to navigating away — the exact behaviour we're removing.
    var appSwatch = el.closest('[class*="tpo_color-swatch"], [class*="tpo_image-swatch"], [class*="tpo_option-type-"]');
    var inScope = appSwatch ||
      (productSection && productSection.contains(el)) ||
      (form && form.contains(el));
    if (!inScope) return false;
    // [class*=] on the Pair-With widgets: their roots are PairPane /
    // PairWithCarousel, which an exact class selector would miss.
    if (el.closest('[class*="PairWith"], [class*="PairPane"], .BundleColors, .BundleTiers, .Product__SlideshowNav, .ProductRecommendations, .Product__Description, .ProductMeta__Description, .Drawer, .CartDrawer, .Cart, .mini-cart')) return false;
    if (!el.closest('[class*="tpo_option-type-"], [class*="tpo_color-swatch"], [class*="tpo_image-swatch"], .ColorSwatchList, .ColorSwatch, .ProductForm__Option, .ProductForm__Variants')) return false;
    // Real swatches are icons, not sentences.
    return swatchTextLength(el) <= 40;
  }

  // Measure the app's own label and nothing else.
  //
  // The app pretty-prints its swatches, so a one-word label arrives wrapped in
  // ~140 characters of newlines and indentation; a raw trim() only strips the
  // ends, leaving all of it. That stayed under the limit by luck until we
  // appended our own count badge, whose digit sat on the far side of that
  // whitespace and pushed the total over — so from the second tap onwards the
  // swatch stopped being recognised, the click sailed through to the browser
  // and the page navigated away. Collapsing the whitespace (and ignoring our
  // badge) measures what was actually meant: the label.
  function swatchTextLength(el) {
    var text = el.textContent || '';
    var badge = el.querySelector('.BundleSwatch__Badge');
    if (badge && badge.textContent) text = text.replace(badge.textContent, '');
    return text.replace(/\s+/g, ' ').trim().length;
  }

  // Every colour swatch on the page that points at a product. Looks inside the
  // product section AND at any option block the app injected elsewhere.
  function allSwatches() {
    var roots = [];
    if (productSection) roots.push(productSection);
    Array.prototype.push.apply(roots, document.querySelectorAll('[class*="tpo_option-type-"]'));

    var out = [];
    roots.forEach(function (root) {
      root.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
        if (out.indexOf(a) === -1 && isSwatch(a)) out.push(a);
      });
    });
    return out;
  }

  // ── click interception ──────────────────────────────────────────────────────
  // Capture phase + stopImmediatePropagation, so neither the Easify app nor
  // color-ajax-nav.js gets a chance to navigate.
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var swatch = e.target.closest(
      'a[href*="/products/"], .tpo_color-swatches-wrapper, .tpo_image-swatches-wrapper, .BundleColors__Swatch, .ColorSwatch'
    );
    if (!swatch || !isSwatch(swatch)) return;

    var handle = handleFromSwatch(swatch);
    // No product behind this swatch — leave it entirely alone so the theme or
    // the app can do whatever it normally does.
    if (!handle) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // What we already know about the product wins over the styling class,
    // which is shared by both "gone" and "sold out".
    // Shopify's /cart/add.js is all-or-nothing: one bad line makes the whole
    // pack fail, so neither kind may enter the pack.
    var known = productCache[handle];
    var name = labelFromSwatch(swatch) || 'That colour';
    if (known === null) {
      notice(name, 'is no longer available.');
      return;
    }
    if (known && !known.available) {
      notice(name, 'is sold out right now.');
      return;
    }
    if (swatch.classList.contains('BundleSwatch--dead')) {
      notice(name, 'is not available right now.');
      return;
    }

    userTouched = true;
    addUnit(handle, labelFromSwatch(swatch), styleFromSwatch(swatch));
  }, true);

  // ── the pack survives leaving the page ──────────────────────────────────────
  // Belt and braces. Clicking a colour should never navigate now, but if some
  // link slips past us — or the customer opens a colour in a new tab, or hits
  // back — losing a half-built pack is the worst thing that can happen. So the
  // pack rides along in sessionStorage and comes back.
  var STORAGE_KEY = 'snakesPack';
  var PACK_TTL = 30 * 60 * 1000;
  var restoreDone = false;
  // Set only by real customer actions, never by our own housekeeping.
  var userTouched = false;

  function savePack() {
    try {
      if (!window.sessionStorage) return;
      // Until we've had a chance to read the stored pack, writing would erase
      // it — the first render happens before the app's swatches exist.
      if (!restoreDone) return;
      // Already in the cart: don't restore it somewhere else and risk a
      // double add. An empty pack only clears storage if the customer emptied
      // it themselves; simply landing on a page with no colours must not throw
      // away a pack they built elsewhere.
      if (!picks.length || packSignature() === addedSignature) {
        if (userTouched) sessionStorage.removeItem(STORAGE_KEY);
        return;
      }
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        t: new Date().getTime(),
        picks: picks.map(function (p) {
          return { handle: p.handle, label: p.label, qty: p.qty, style: p.style, image: p.image };
        })
      }));
    } catch (e) {}
  }

  // Only restores colours that actually belong to the swatch set on this page,
  // so a pack of sarongs never reappears on an unrelated product.
  function restorePack(handlesOnPage) {
    if (restoreDone) return;
    restoreDone = true;
    try {
      if (!window.sessionStorage) return;
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      if (!data || !data.picks || !data.picks.length) return;
      if (new Date().getTime() - (data.t || 0) > PACK_TTL) {
        sessionStorage.removeItem(STORAGE_KEY);
        return;
      }

      var allowed = {};
      handlesOnPage.forEach(function (h) { allowed[h] = true; });
      if (current.handle) allowed[current.handle] = true;

      var kept = data.picks.filter(function (p) { return p.handle && allowed[p.handle] && p.qty > 0; });
      if (!kept.length) return;

      picks = kept.map(function (p) {
        return {
          handle: p.handle,
          label: p.label || '',
          style: p.style || '',
          image: p.image || '',
          variantId: p.handle === current.handle ? current.variantId : '',
          qty: p.qty,
          pending: true
        };
      });
      lastTouched = picks[picks.length - 1].handle;
      sync();

      // Re-check every restored colour against the catalog — stock and
      // availability may have moved on since it was saved.
      picks.slice().forEach(function (p) {
        resolveProduct(p.handle).then(function (data2) {
          p.pending = false;
          if (!data2 || !data2.available) {
            removePick(p.handle);
            markDead(p.handle, !data2);
            return;
          }
          p.variantId = data2.variantId;
          if (data2.colour) p.label = data2.colour;
          if (data2.image) p.image = data2.image;
          sync();
        });
      });
    } catch (e) {}
  }

  // ── pack state ──────────────────────────────────────────────────────────────
  function findPick(handle) {
    for (var i = 0; i < picks.length; i++) {
      if (picks[i].handle === handle) return picks[i];
    }
    return null;
  }

  function addUnit(handle, label, style) {
    var pick = findPick(handle);
    if (pick) {
      pick.qty += 1;
    } else {
      pick = {
        handle: handle,
        label: label || '',
        style: style || '',
        image: '',
        variantId: handle === current.handle ? current.variantId : '',
        qty: 1,
        pending: true
      };
      picks.push(pick);
    }
    lastTouched = handle;
    clearNotice();
    sync();

    resolveProduct(handle).then(function (data) {
      pick.pending = false;
      if (!data || !data.available) {
        // The linked product is gone or sold out. Pull it straight back out —
        // one bad line would otherwise fail the entire add-to-cart.
        removePick(handle);
        markDead(handle, !data);
        if (lastTouched === handle) lastTouched = current.handle;
        notice(
          (data && data.colour) || pick.label || 'That colour',
          data ? 'is sold out — removed from your pack.' : 'is no longer available — removed from your pack.'
        );
        return;
      }
      pick.variantId = data.variantId;
      if (data.colour) pick.label = data.colour;
      if (data.image) pick.image = data.image;
      sync();
    });
  }

  function removeUnit(handle) {
    var pick = findPick(handle);
    if (!pick) return;
    pick.qty -= 1;
    if (pick.qty <= 0) removePick(handle);
    sync();
  }

  function removePick(handle) {
    picks = picks.filter(function (p) { return p.handle !== handle; });
    sync();
  }

  // Tapping a tier card sets what the customer is AIMING for. It must not pick
  // colours for them and must not throw away colours they already picked —
  // both of those made the tiers feel like they were fighting the customer.
  function setTarget(n) {
    var want = Math.max(0, n);
    var have = total();
    // Goal already met or beaten: there is nothing to count down to, and the
    // bigger pack keeps the better discount.
    targetQty = have >= want ? 0 : want;
    clearNotice();
    if (want > 0 && have > want) {
      notice('', 'Your pack already has ' + have + ' in it — use the minus button on a colour to take some out.');
    }
    sync();
  }

  // The +/- buttons set an absolute total; the difference goes to (or comes
  // off) the colour the customer last touched. Only these buttons and the
  // colour swatches ever change the pack.
  function setTotal(target) {
    target = Math.max(0, target);

    // Never top up with a colour we know is gone or sold out — the tier button
    // would look like it did nothing.
    var topUp = lastTouched || current.handle;
    var known = productCache[topUp];
    if (known === null || (known && !known.available)) topUp = current.handle;

    var guard = 0;
    // Without a colour to top up with we can still trim, so this only skips
    // the growth half rather than failing the whole button.
    while (topUp && total() < target && guard++ < 200) {
      var pick = findPick(topUp);
      if (pick) {
        pick.qty += 1;
      } else {
        addUnit(topUp, current.label, '');
      }
    }
    while (total() > target && picks.length && guard++ < 400) {
      var last = picks[picks.length - 1];
      last.qty -= 1;
      if (last.qty <= 0) picks.pop();
    }
    sync();
  }

  // ── rendering ───────────────────────────────────────────────────────────────
  function sync() {
    var qty = total();
    if (targetQty && qty >= targetQty) targetQty = 0;
    // With no colours chosen the form still adds the colour this page is, so
    // the goal is the quantity — that is the plain "3 of this one" path.
    var shown = qty || targetQty || 1;
    hiddenInput.value = Math.max(1, shown);

    tiersWrap.querySelectorAll('[data-bundle-qty-display]').forEach(function (el) {
      el.textContent = shown;
    });
    tiersWrap.querySelectorAll('[data-bundle-decrease]').forEach(function (btn) {
      btn.disabled = shown <= 1;
    });

    // The pack panel only exists once there is a pack.
    if (colorSection) colorSection.style.display = qty ? '' : 'none';

    highlightTier(qty);
    renderPicks();
    renderBadges();
    updateCount(qty);
    updateExpressCheckout();
    if (typeof refreshStickyMode === 'function' && stickyBtn) refreshStickyMode();
    savePack();
  }

  // The dynamic checkout button ("Buy it now") submits the form natively, so it
  // can only ever buy the product this page is. If the pack holds anything
  // else, that button would quietly checkout the wrong thing — hide it.
  function updateExpressCheckout() {
    var express = document.querySelector('.shopify-payment-button');
    if (!express) return;
    var mixed = picks.some(function (p) { return p.handle !== current.handle; });
    express.style.display = mixed ? 'none' : '';
  }

  function tierFor(qty) {
    var best = tierData[0];
    for (var i = tierData.length - 1; i >= 0; i--) {
      if (qty >= tierData[i].qty) { best = tierData[i]; break; }
    }
    return best;
  }

  function highlightTier(qty) {
    // The highlighted card leads the way to the goal while the pack is still
    // short of it; otherwise it simply reports what the pack has earned.
    var goal = targetQty > qty ? targetQty : qty;
    var best = tierFor(goal);

    tiers.forEach(function (t) { t.classList.remove('BundleTier--selected'); });
    if (best && best.el) best.el.classList.add('BundleTier--selected');

    // Before anything is picked, price the goal (or a single item) rather than
    // flashing a $0.00 total. The discount is whatever the quantity actually
    // being charged earns — never the goal's.
    var priceQty = qty || targetQty || 1;
    var earned = tierFor(priceQty);
    var discount = earned ? earned.discount : 0;
    var remaining = targetQty > qty ? targetQty - qty : 0;

    tiersWrap.querySelectorAll('[data-bundle-active-tier]').forEach(function (tag) {
      if (remaining > 0 && qty > 0 && best && best.discount > 0) {
        tag.textContent = 'Choose ' + remaining + ' more colour' + (remaining > 1 ? 's' : '') +
          ' for ' + best.discount + '% off';
        tag.setAttribute('data-has-discount', '');
      } else if (discount > 0) {
        tag.textContent = discount + '% discount applied';
        tag.setAttribute('data-has-discount', '');
      } else {
        tag.textContent = '';
        tag.removeAttribute('data-has-discount');
      }
    });

    var fullTotal = basePrice * priceQty;
    var each = Math.round(basePrice * (100 - discount) / 100);
    var discountedTotal = each * priceQty;
    var savings = fullTotal - discountedTotal;

    tiersWrap.querySelectorAll('[data-bundle-price-summary]').forEach(function (el) {
      var html = '<span class="BundleTier__PriceTotal">' + formatMoney(discountedTotal) + '</span>';
      if (savings > 0) {
        html += '<span class="BundleTier__PriceWas">' + formatMoney(fullTotal) + '</span>';
        html += '<span class="BundleTier__PriceSave">Save ' + formatMoney(savings) + '</span>';
      }
      html += '<br><span style="font-size:11px;color:#888;">' + priceQty + ' × ' + formatMoney(each) + ' ea</span>';
      el.innerHTML = html;
    });

    if (addToCartPriceSpan.length >= 3) {
      addToCartPriceSpan[2].textContent = formatMoney(discountedTotal);
    }

    updateStickyBar(discountedTotal, discount);
  }

  function renderPicks() {
    if (!picksEl) return;

    // Nothing chosen yet: the whole panel is hidden by sync(), so there is no
    // empty state to write. An empty box captioned "nothing in your pack" is
    // just noise above the colours it is asking you to tap.
    if (!picks.length) {
      picksEl.innerHTML = '';
      return;
    }

    // Any pick still missing its colour gets one from its swatch on the page.
    if (picks.some(function (p) { return !p.style; })) {
      picks.forEach(function (p) {
        if (!p.style) p.style = styleForHandle(p.handle);
      });
    }

    var html = '';
    picks.forEach(function (p) {
      // Colour first. The product photo is only a last resort — at 18px across
      // a shot of a folded sarong is an unreadable smudge, and the customer is
      // trying to check which colours they chose.
      var dot = p.style
        ? ' style="' + escapeAttr(p.style) + '"'
        : (p.image ? " style=\"background-image:url('" + escapeAttr(p.image) + "')\"" : '');
      html += '<span class="BundleColors__Pick' + (p.pending ? ' is-pending' : '') + '" data-pick-handle="' + escapeAttr(p.handle) + '">';
      html += '<span class="BundleColors__PickDot"' + dot + '></span>';
      html += '<span class="BundleColors__PickName">' + escapeHtml(p.label || p.handle) + '</span>';
      html += '<span class="BundleColors__PickStepper">';
      html += '<button type="button" class="BundleColors__PickBtn" data-pick-dec aria-label="Remove one ' + escapeAttr(p.label) + '">&minus;</button>';
      html += '<span class="BundleColors__PickCount">' + p.qty + '</span>';
      html += '<button type="button" class="BundleColors__PickBtn" data-pick-inc aria-label="Add one more ' + escapeAttr(p.label) + '">&plus;</button>';
      html += '</span>';
      html += '<button type="button" class="BundleColors__PickX" data-pick-remove aria-label="Remove ' + escapeAttr(p.label) + '">&times;</button>';
      html += '</span>';
    });
    picksEl.innerHTML = html;
  }

  if (picksEl) {
    picksEl.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var chip = e.target.closest('[data-pick-handle]');
      if (!chip) return;
      var handle = chip.getAttribute('data-pick-handle');
      e.preventDefault();
      e.stopPropagation();
      userTouched = true;

      if (e.target.closest('[data-pick-inc]')) {
        lastTouched = handle;
        var pick = findPick(handle);
        if (pick) { pick.qty += 1; sync(); }
      } else if (e.target.closest('[data-pick-dec]')) {
        lastTouched = handle;
        removeUnit(handle);
      } else if (e.target.closest('[data-pick-remove]')) {
        removePick(handle);
      }
    });
  }

  // A little counter on each swatch, so "click it three times" is legible.
  function renderBadges() {
    allSwatches().forEach(function (a) {
      var handle = handleFromSwatch(a);
      if (!handle) return;
      var pick = findPick(handle);
      var badge = a.querySelector('.BundleSwatch__Badge');

      if (!pick) {
        if (badge) badge.remove();
        a.classList.remove('BundleSwatch--picked');
        return;
      }
      a.classList.add('BundleSwatch--picked');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'BundleSwatch__Badge';
        if (getComputedStyle(a).position === 'static') a.style.position = 'relative';
        a.appendChild(badge);
      }
      // Only write when it actually changed — this element sits inside the
      // node our own MutationObserver is watching, so a blind write would
      // retrigger the observer forever.
      if (badge.textContent !== String(pick.qty)) badge.textContent = String(pick.qty);
    });
  }

  // gone === true  -> the product no longer exists (broken swatch link)
  // gone === false -> the product exists but is sold out
  function markDead(handle, gone) {
    allSwatches().forEach(function (a) {
      if (handleFromSwatch(a) !== handle) return;
      a.classList.add('BundleSwatch--dead');
      a.setAttribute('aria-disabled', 'true');
      // Don't clobber a tooltip the app set for its own use.
      if (!a.getAttribute('title')) {
        a.setAttribute('title', gone ? 'Currently unavailable' : 'Sold out');
      }
    });
  }

  function markCurrent() {
    allSwatches().forEach(function (a) {
      if (current.handle && handleFromSwatch(a) === current.handle) {
        a.classList.add('BundleSwatch--current');
      }
    });
  }

  function updateCount(qty) {
    if (!countEl) return;
    // No pack, no panel — so there is nothing to caption.
    if (!qty) {
      countEl.textContent = '';
      return;
    }
    countEl.textContent = targetQty > qty
      ? qty + ' of ' + targetQty + ' chosen'
      : qty + ' in your pack';
    countEl.style.color = '#4e4d4d';
  }

  function notice(subject, message) {
    if (!noticeEl) return;
    noticeEl.textContent = (subject ? subject + ' ' : '') + message;
    noticeEl.style.display = 'block';
    clearTimeout(notice._timer);
    notice._timer = setTimeout(clearNotice, 4000);
  }

  function clearNotice() {
    if (!noticeEl) return;
    noticeEl.textContent = '';
    noticeEl.style.display = 'none';
  }

  // ── swatch discovery: validate links, flag dead ones, reveal the panel ──────
  var validated = {};
  function initSwatches() {
    var swatches = allSwatches();
    if (!swatches.length) return;

    // Visibility belongs to sync(), which knows whether there is a pack yet.
    markCurrent();
    renderBadges();

    // Now that we know which colours this page offers, bring back any pack the
    // customer had already started.
    restorePack(swatches.map(handleFromSwatch).filter(Boolean));

    swatches.forEach(function (a) {
      var handle = handleFromSwatch(a);
      if (!handle || validated[handle]) {
        // Re-flag after the app re-renders its swatches from scratch.
        var cached = handle ? productCache[handle] : undefined;
        if (cached === null) markDead(handle, true);
        else if (cached && !cached.available) markDead(handle, false);
        return;
      }
      validated[handle] = true;
      resolveProduct(handle).then(function (data) {
        if (!data || !data.available) markDead(handle, !data);
      });
    });
  }

  function watchSwatches() {
    // Throttle, not debounce. The Easify app mutates this subtree constantly
    // while it renders, and our own badges mutate it too — a resetting debounce
    // could postpone validation indefinitely and leave dead colours unflagged.
    var queued = false;
    var run = function () {
      if (queued) return;
      queued = true;
      setTimeout(function () {
        queued = false;
        initSwatches();
        renderBadges();
      }, 120);
    };

    initSwatches();
    [0, 400, 900, 1800, 3200].forEach(function (d) { setTimeout(run, d); });
    // If the app never renders any swatches, unblock saving anyway.
    setTimeout(function () {
      if (!restoreDone) restorePack(allSwatches().map(handleFromSwatch).filter(Boolean));
    }, 4000);

    var observer = new MutationObserver(function (records) {
      // Our own pack panel re-renders constantly; reacting to that would just
      // spin the swatch scan for nothing.
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (!colorSection || !t || !colorSection.contains(t)) { run(); return; }
      }
    });
    observer.observe(productSection || document.body, { childList: true, subtree: true });
  }

  // ── tier interactions ───────────────────────────────────────────────────────
  tiers.forEach(function (tier) {
    var header = tier.querySelector('.BundleTier__Header');
    if (!header) return;
    header.addEventListener('click', function (e) {
      e.preventDefault();
      userTouched = true;
      setTarget(parseInt(tier.getAttribute('data-tier-qty'), 10) || 1);
    });
  });

  // Before any colour is chosen these nudge the goal; once there is a pack,
  // they add to / take from the colour last touched.
  function step(delta) {
    if (picks.length) setTotal(total() + delta);
    else setTarget(Math.max(1, (targetQty || 1) + delta));
  }

  tiersWrap.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('[data-bundle-decrease]')) {
      e.preventDefault();
      e.stopPropagation();
      userTouched = true;
      step(-1);
    }
    if (e.target.closest('[data-bundle-increase]')) {
      e.preventDefault();
      e.stopPropagation();
      userTouched = true;
      step(1);
    }
  });

  // ── add to cart ─────────────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest('[data-action="add-to-cart"], .ProductForm__AddToCart');
    if (!btn) return;
    var btnForm = btn.closest('form[action*="/cart/add"]');
    if (!btnForm || btnForm !== form) return;
    if (!picks.length) return;   // nothing picked — let the theme add the page's own product
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    runBundleAdd(btn);
  }, true);

  if (form) {
    form.addEventListener('submit', function (e) {
      if (!picks.length) return;
      e.preventDefault();
      e.stopPropagation();
      runBundleAdd(form.querySelector('[data-action="add-to-cart"], .ProductForm__AddToCart'));
    });
  }

  // Carry across any line-item properties the form is collecting (engraving,
  // gift notes, other Easify options...) so nothing is lost.
  function formProperties() {
    var props = {};
    if (!form || typeof FormData === 'undefined') return props;
    try {
      new FormData(form).forEach(function (value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value) props[match[1]] = value;
      });
    } catch (err) {}
    return props;
  }

  function runBundleAdd(addBtn) {
    var label = addBtn ? addBtn.querySelector('span') : null;
    var originalText = label ? label.textContent : '';

    if (addBtn) {
      addBtn.disabled = true;
      if (label) label.textContent = 'Adding...';
    }

    // Anything we cannot resolve to a variant gets left behind. Saying so is
    // the whole point — a pack of five that silently becomes a cart of two is
    // the one failure the customer will never forgive.
    var dropped = [];

    Promise.all(picks.map(function (p) {
      if (p.variantId) return Promise.resolve();
      return resolveProduct(p.handle).then(function (data) {
        if (data) p.variantId = data.variantId;
      });
    }))
      .then(function () {
        var props = formProperties();
        picks.forEach(function (p) {
          if (!p.variantId) dropped.push(p.label || p.handle);
        });
        var items = picks
          .filter(function (p) { return p.variantId; })
          .map(function (p) {
            var item = { id: parseInt(p.variantId, 10), quantity: p.qty };
            if (Object.keys(props).length) item.properties = props;
            return item;
          })
          .filter(function (item) { return item.id && !isNaN(item.id) && item.quantity > 0; });

        if (!items.length) throw new Error('No valid colours in your pack');

        return fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            throw new Error(body.description || 'Could not add to cart');
          });
        }
        return r.json();
      })
      .then(function () {
        if (label) label.textContent = 'Added to cart!';
        var added = total();
        if (dropped.length) {
          notice('', dropped.join(' and ') + ' could not be added — everything else is in your bag.');
        }
        addedSignature = packSignature();
        // This pack is in the cart now. Drop the saved copy immediately —
        // a restored pack that was never "touched" on this page would
        // otherwise linger and could be added a second time elsewhere.
        userTouched = true;
        try { if (window.sessionStorage) sessionStorage.removeItem(STORAGE_KEY); } catch (e) {}
        setTimeout(function () {
          if (addBtn) addBtn.disabled = false;
          if (label) label.textContent = originalText || 'Add to cart';
        }, 2000);
        document.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { quantity: added } }));
        document.dispatchEvent(new CustomEvent('cart:updated'));
      })
      .catch(function (err) {
        if (addBtn) addBtn.disabled = false;
        if (label) label.textContent = originalText || 'Add to cart';
        notice('', (err && err.message) || 'Something went wrong — please try again.');
      });
  }

  // ── money ───────────────────────────────────────────────────────────────────
  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100));
  }

  function escapeHtml(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }
  function escapeAttr(s) { return (s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); }

  // ── sticky bottom bar ───────────────────────────────────────────────────────
  var productImage = tiersWrap.getAttribute('data-product-image') || '';
  var stickyBar = document.createElement('div');
  stickyBar.className = 'BundleStickyBar';
  stickyBar.innerHTML = '<div class="BundleStickyBar__Inner">' +
    (productImage ? '<img class="BundleStickyBar__Img" src="' + escapeAttr(productImage) + '" alt="">' : '') +
    '<div class="BundleStickyBar__Info">' +
      '<span class="BundleStickyBar__Product"></span>' +
      '<span class="BundleStickyBar__Price"></span>' +
    '</div>' +
    '<button type="button" class="BundleStickyBar__Btn" data-sticky-action="add">Add to cart</button>' +
  '</div>';
  document.body.appendChild(stickyBar);

  var stickyProductName = stickyBar.querySelector('.BundleStickyBar__Product');
  var stickyPriceEl = stickyBar.querySelector('.BundleStickyBar__Price');
  var stickyBtn = stickyBar.querySelector('.BundleStickyBar__Btn');
  var stickyCartTotal = 0;
  var stickyCartCount = 0;
  var stickyMode = 'add';

  var productTitle = document.querySelector('.ProductMeta__Title');
  if (productTitle && stickyProductName) {
    stickyProductName.textContent = productTitle.textContent.trim();
  }

  function fetchCartState() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        stickyCartTotal = cart.total_price;
        stickyCartCount = cart.item_count;
        refreshStickyMode();
      })
      .catch(function () {});
  }

  // What the pack currently holds, so we can tell "already added" from
  // "built but not added yet".
  function packSignature() {
    return picks.map(function (p) { return p.handle + ':' + p.qty; }).join('|');
  }
  var addedSignature = '';

  function refreshStickyMode() {
    // If they have built a pack that isn't in the cart yet, the bar must say
    // "Add to cart" — otherwise they tap Checkout and lose the whole pack.
    var unsaved = picks.length > 0 && packSignature() !== addedSignature;

    if (stickyCartCount > 0 && !unsaved) {
      stickyMode = 'checkout';
      stickyBtn.setAttribute('data-sticky-action', 'checkout');
      stickyBtn.textContent = 'Checkout — ' + formatMoney(stickyCartTotal);
      stickyBtn.classList.add('BundleStickyBar__Btn--checkout');
      if (stickyProductName) stickyProductName.textContent = stickyCartCount + ' item' + (stickyCartCount > 1 ? 's' : '') + ' in your bag';
      if (stickyPriceEl) stickyPriceEl.textContent = '';
    } else {
      stickyMode = 'add';
      stickyBtn.setAttribute('data-sticky-action', 'add');
      stickyBtn.classList.remove('BundleStickyBar__Btn--checkout');
      if (productTitle && stickyProductName) stickyProductName.textContent = productTitle.textContent.trim();
      highlightTier(total());
    }
  }

  function updateStickyBar(totalCents, discount) {
    if (stickyMode !== 'add' || !stickyBtn) return;
    stickyBtn.textContent = 'Add to cart — ' + formatMoney(totalCents);
    if (stickyPriceEl) {
      stickyPriceEl.textContent = discount > 0 ? discount + '% off applied' : '';
    }
  }

  stickyBtn.addEventListener('click', function (e) {
    e.preventDefault();
    if (stickyMode === 'checkout') {
      window.location.href = '/checkout';
    } else if (addToCartBtn) {
      addToCartBtn.click();
    }
  });

  document.addEventListener('product:added', function () { setTimeout(fetchCartState, 400); });
  document.addEventListener('cart:updated', function () { setTimeout(fetchCartState, 400); });

  var _origFetch = window.fetch;
  window.fetch = function () {
    var result = _origFetch.apply(this, arguments);
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url ? arguments[0].url : '');
    if (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1) {
      result.then(function () { setTimeout(fetchCartState, 500); }).catch(function () {});
    }
    return result;
  };

  var _origXHROpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (url && (url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/change') !== -1 || url.indexOf('/cart/update') !== -1)) {
      this.addEventListener('load', function () { setTimeout(fetchCartState, 500); });
    }
    return _origXHROpen.apply(this, arguments);
  };

  var stickyVisible = false;
  function checkSticky() {
    if (!addToCartBtn) return;
    var rect = addToCartBtn.getBoundingClientRect();
    var shouldShow = rect.bottom < 0;
    if (shouldShow !== stickyVisible) {
      stickyVisible = shouldShow;
      stickyBar.classList.toggle('BundleStickyBar--visible', shouldShow);
    }
  }

  var scrollTicking = false;
  window.addEventListener('scroll', function () {
    if (scrollTicking) return;
    scrollTicking = true;
    requestAnimationFrame(function () { checkSticky(); scrollTicking = false; });
  }, { passive: true });

  // ── styles that have to sit on app-rendered swatches ────────────────────────
  var style = document.createElement('style');
  style.textContent =
    '.BundleSwatch__Badge { position: absolute; top: -5px; right: -5px; min-width: 17px; height: 17px; padding: 0 4px; border-radius: 9px; background: #1a1a1a; color: #fff; font-size: 10px; font-weight: 700; line-height: 17px; text-align: center; box-shadow: 0 0 0 2px #fff; pointer-events: none; z-index: 3; }' +
    // No border-radius here on purpose: the outline follows whatever shape the
    // app gave the swatch (circle for colours, square for pattern images).
    '.BundleSwatch--picked { outline: 2px solid #1a1a1a; outline-offset: 2px; }' +
    '.BundleSwatch--current { outline: 1.5px solid #b5b0a8; outline-offset: 2px; }' +
    '.BundleSwatch--dead { opacity: 0.28; filter: grayscale(1); cursor: not-allowed; }' +
    '.BundleSwatch--dead.BundleSwatch--picked { outline: none; }' +
    '.BundleStickyBar { position: fixed; bottom: 0; left: 0; right: 0; z-index: 999; transform: translateY(100%); transition: transform 0.3s ease; background: #fff; border-top: 1px solid #e5e5e5; box-shadow: 0 -4px 20px rgba(0,0,0,0.08); padding: 0; }' +
    '.BundleStickyBar--visible { transform: translateY(0); }' +
    '.BundleStickyBar__Inner { max-width: 1200px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; padding: 12px 20px; gap: 14px; }' +
    '.BundleStickyBar__Img { width: 44px; height: 44px; border-radius: 8px; object-fit: cover; flex-shrink: 0; border: 1px solid #eee; }' +
    '.BundleStickyBar__Info { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1; }' +
    '.BundleStickyBar__Product { font-size: 13px; font-weight: 600; color: #1a1a1a; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }' +
    '.BundleStickyBar__Price { font-size: 12px; color: #059669; font-weight: 600; }' +
    '.BundleStickyBar__Btn { flex-shrink: 0; background: #1a1a1a; color: #fff; border: none; padding: 12px 28px; border-radius: 8px; font-size: 14px; font-weight: 600; cursor: pointer; letter-spacing: 0.02em; transition: all 0.25s ease; }' +
    '.BundleStickyBar__Btn:hover { background: #333; }' +
    '@media (max-width: 640px) { .BundleStickyBar__Inner { padding: 10px 16px; } .BundleStickyBar__Btn { padding: 11px 20px; font-size: 13px; } }';
  document.head.appendChild(style);

  // ── boot ────────────────────────────────────────────────────────────────────
  clearNotice();
  sync();
  watchSwatches();
  fetchCartState();
})();
